module.exports = __webpack_public_path__ + "img/scene4-3D.1d06d09e.gif";